/**
 * @generated SignedSource<<a05d92d748f70e7c7d72f1b6a9bef514>>
 * @relayHash c0e36d52cfb862adc1be257a38f6c031
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 452d87ee86ac56020d83c1f701ce0f1cb07fe3a482921ec4bdec094f34a526a6

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ProductsQueryQuery$variables = {
  cloudId: string;
  first: number;
};
export type ProductsQueryQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ProductsPage">;
};
export type ProductsQueryQuery = {
  response: ProductsQueryQuery$data;
  variables: ProductsQueryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  }
],
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v3 = [
  (v2/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ProductsQueryQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          (v2/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "ProductsPage"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProductsQueryQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/)
        ],
        "concreteType": "CustomerServiceQueryApi",
        "kind": "LinkedField",
        "name": "customerService",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "CustomerServiceProductConnection",
            "kind": "LinkedField",
            "name": "productConnections",
            "plural": false,
            "selections": [
              {
                "concreteType": "CustomerServiceProductEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "CustomerServiceProduct",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "name"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "entitlementsCount"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "cursor"
                  }
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "endCursor"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                  }
                ]
              },
              {
                "kind": "ClientExtension",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__id"
                  }
                ]
              }
            ]
          },
          {
            "args": (v3/*: any*/),
            "handle": "connection",
            "key": "customerServiceProducts_productConnections",
            "kind": "LinkedHandle",
            "name": "productConnections"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "452d87ee86ac56020d83c1f701ce0f1cb07fe3a482921ec4bdec094f34a526a6",
    "metadata": {},
    "name": "ProductsQueryQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "28152f0db7bfe5cf936163bfadb93f33";

export default node;
